export default __webpack_public_path__ + "static/tb_helles_03_EN-74e7e8388a5bcce00711af4159ace56d.svg";